<template>
  
        <div class="container">

          <!-- Basic Information Section -->
          <div class="section">
                  <h3>Rent Wonderland  </h3>     
            <img alt="logo" src="../assets/logo.png" height="200" />
  <br/>
      <i>Warehouse 1-3, Dairy building, Villa and outside</i>
          </div>
  
   <div class="section">

                <h3>Membership</h3>
    <label for="locationName">Is it a Wonder Studios event and does everyone needs to be a member?</label>
      <input type="checkbox" v-model="payload.internal"  /> 
    </div> 

     <div class="section">
      <ui>
           <li> <h3>Participants</h3>
                <label for="volunteers">How many participants?</label>
                <input type="number" id="volunteers" v-model="payload.participants"  min="0"/> </li>
        <li>
               <h3>Volunteers</h3>
                <label for="participants">How many volunteers?</label>
                <input type="number" id="participants" v-model="payload.volunteers"  min="0"/> 

        </li>
     
      </ui>
                

     </div> 
     
      <div class="section">
                  <h3>Days</h3>
                   <ul> 
       <li>
              <b>Days (Activity with participants):</b>  <br/><input type="number" v-model="payload.days.acitivity"   min="0"/>
         <br/><i> {{ payload.internal ? formatToDKK(payload.prices.location.internal, true) : formatToDKK(payload.prices.location.external, true) }}</i>
            </li> 
              <li>
                <b>Days (Production with volunteers):</b>  <br/><input type="number" v-model="payload.days.production"   min="0"/>
                 <br/><i> {{ payload.internal ? formatToDKK(payload.prices.location.internal, true) : formatToDKK(payload.prices.location.external, true) }}</i>
              </li> 
      </ul>
                  </div> 
     <h3>Facilities</h3>
     <i>The locations has one bathroom (toilet + bath) in the Villa and four pissoirs outside.</i>
        <ul>
           <li>
               Add the Bath Wagon (8 baths + 2 toilets)  (Minimum 2000,00 kr.):  <br/>Ja<input  min="0" type="checkbox" v-model="payload.baths"/> {{ payload.internal ? formatToDKK(payload.prices.baths.internal, true) : formatToDKK(payload.prices.baths.external, true) }} 
              </li> 
               <li>
                 Add the 10 toilets  (Minimum 2000,00 kr.):  <br/>Ja<input type="checkbox"  min="0" v-model="payload.toilets"/> {{ payload.internal ? formatToDKK(payload.prices.toilets.internal,true) : formatToDKK(payload.prices.toilets.external,true) }}  
                </li> 
        </ul>
      <ul>
         
      </ul> 
    <hr>
    <ul>
      <li>
       <h2>Price + deposit:  {{ formatToDKK(payload.totalPrice)  }} + {{ formatToDKK(payload.totalDeposit) }} DKK</h2>
      <i> Ex. usages (Electricity, Water etc.)</i><br/>
      <i>{{ payload.minimumText }}</i>
      </li> 
    </ul> 
    <ul>
        <li>
        <table border="1">
        <tr>
          <th style="width:100px">Desciption</th>
          <th>Price</th>
        </tr>
        <tr>
          <td>Location</td>
          <td>{{ formatToDKK(payload.totalLocation) }}</td>
        </tr>
         <tr>
            <td>Toilet wagon</td>
            <td>{{ formatToDKK(payload.totalToilets) }}</td>
          </tr>
           <tr>
              <td>Bath wagon</td>
              <td>{{ formatToDKK(payload.totalBaths) }}</td>
            </tr>
      </table>
        </li> 
      </ul>
     <h1>Average price pr. participant</h1>
      <ul>
        <li>
         <h2> {{ formatToDKK(payload.averagePrice) }}</h2>
        </li> 
      </ul>
  </div> 

</template>

<script setup>
import {   onMounted, ref, watch } from 'vue';


const payload = ref({
  minimumText:   'Minimumprice is 2000 kr.',
  minimumPrice: 2000,
  toilets: false,
  baths: false,
  internal: true,
  participants: 40, 
  volunteers: 10,
  days: 
  {
    acitivity: 2,
    production: 1
  },
  prices: {  
    location: {
      internal: 30,
      external: 100
    },
    toilets: {
      internal: 10,
      external: 20
    },
    baths: {
      internal: 10,
      external: 20
    },
  },
  totalPrice: 0.0,
  totalDeposit: 0.0,
  averagePrice: 0.0,
  totalLocation: 0.0,
  totalToilets: 0.0,
  totalBaths: 0.0,
 
});

onMounted(() => {
  calculatePrice();
});

watch([payload.value], () => { 
   calculatePrice();
});


const formatToDKK = (value, prPerson) => {
  if (!value) return "0,00 kr.";
  if(prPerson) {
    return value.toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " kr. pr. person pr. day";
  } else {
    return value.toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " kr.";
  } 
}

const calculatePrice = () => {   
  const pricePrPersonLocation = ref(0);
  const pricePrPersonToilet = ref(0);
  const pricePrPersonBath = ref(0);
  const priceLocation = ref(0);
  const priceToilet = ref(0);
  const priceBath = ref(0);

  //Location rental
  if(payload.value.internal) {
    pricePrPersonLocation.value = payload.value.prices.location.internal;
    pricePrPersonToilet.value = payload.value.prices.baths.internal;
    pricePrPersonBath.value = payload.value.prices.baths.internal;
  } else {
    pricePrPersonLocation.value = payload.value.prices.location.external;
    pricePrPersonToilet.value = payload.value.prices.baths.external;
    pricePrPersonBath.value = payload.value.prices.baths.external;
  } 
    priceLocation.value = (payload.value.participants * payload.value.days.acitivity * pricePrPersonLocation.value) + (payload.value.volunteers * payload.value.days.production * pricePrPersonLocation.value)
    
    priceToilet.value = (payload.value.participants * payload.value.days.acitivity * pricePrPersonToilet.value) + (payload.value.volunteers * payload.value.days.production * pricePrPersonToilet.value)
   
    priceBath.value = (payload.value.participants * payload.value.days.acitivity * pricePrPersonBath.value) + (payload.value.volunteers * payload.value.days.production * pricePrPersonBath.value)
    if(priceBath.value < payload.value.minimumPrice) {
      priceBath.value = payload.value.minimumPrice;
    }
    if(priceToilet.value < payload.value.minimumPrice) {
      priceToilet.value = payload.value.minimumPrice;
    }
    if (priceLocation.value < payload.value.minimumPrice) {
      priceLocation.value = payload.value.minimumPrice;
    }
  payload.value.totalLocation = priceLocation.value;
  payload.value.totalToilets  = payload.value.toilets ? priceToilet.value : 0;
  payload.value.totalBaths    = payload.value.baths ? priceBath.value : 0;
  payload.value.totalPrice    = payload.value.totalLocation + payload.value.totalToilets + payload.value.totalBaths;
  payload.value.totalDeposit =  payload.value.totalPrice * 0.10;
  if(payload.value.totalPrice === 0) {
    payload.value.averagePrice = 0;
  } else {
    payload.value.averagePrice = payload.value.totalPrice / payload.value.participants
  } 
};

 

  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
} 

input[type="number"],
input[type="password"],
input[type="email"],
textarea {
    text-align: center;
    width: 3rem;
    padding: 1rem;
    margin-bottom: 20px;
    border: 1px solid #E1E8ED;
    border-radius: 4px;
    font-size: 14px;
}


body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #F5F8FA;
    margin: 0;
    padding: 0;
}

.container {
    max-width: 50rem;
    margin: 50px auto;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.section {
    padding: 10px;
    border-bottom: 1px solid #E1E8ED;
    margin-bottom: 10px;
} 

h3 {
    border-bottom: 1px solid #E1E8ED;
    padding-bottom: 10px;
    margin-top: 20px;
}

label {
    display: block;
    margin: 10px 0;
}

button {
    display: block;
    background-color: #1DA1F2;
    color: #ffffff;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
}
</style>
